import React from 'react';
import ReactDOM from "react-dom/client";
import './index.css';
import reportWebVitals from './reportWebVitals';
import "./fonts/B Ziba_0.ttf";
import "./fonts/IRANSans.ttf";
import "./fonts/IRANYekanX-Regular.ttf";
import Routing from './routes';
import { createTheme, ThemeProvider} from '@mui/material/styles';



const theme = createTheme({
  typography: {
   //"fontFamily": `"B Ziba_0"`,   
    "fontFamily": `IRANYekanX-Regular`
   //"fontFamily": `IRANSans`
  }
});


const root = ReactDOM.createRoot(document.getElementById("root"));

const App = () => (
  
  <ThemeProvider theme={theme}>

     <Routing />

  </ThemeProvider>
);


root.render(
   
          <App />


   
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
